/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import Screens from '../../constants/routing/Screens';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { usePageParams } from '../../hooks/usePageParams';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SplashPageBanner from './SplashPageBanner';
import SplashPageHeader from './SplashPageHeader';
import ProductsSection from './ProductsSection';
import SegmentedTabs from '../layout/tabs/SegmentedTabs';
import SuiteSection from './suite-section/SuiteSection';
import PowerOfHubSpotSection from './PowerOfHubSpotSection';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import FailedLoadBanner from '../common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../common/loading/FallbackErrorBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SplashPage = () => {
  useTrackRetail();
  useDocumentTitle('default');
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const isAppAuth = useSelector(isAppAuthSelector);
  const {
    tab = ENTERPRISE
  } = usePageParams();
  useEffect(() => {
    getUsageTracker().track('pageView', Object.assign({
      screen: Screens.SPLASH
    }, !isAppAuth && {
      tab
    }));
  }, [tab]);
  return /*#__PURE__*/_jsxs("div", {
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: "SPLASH_PAGE"
    }), /*#__PURE__*/_jsx(FailedLoadBanner, {
      hasFailed: hasPricingAndPurchasingFailed
    }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), !isAppAuth && /*#__PURE__*/_jsxs(SplashPageBanner, {
      children: [/*#__PURE__*/_jsx(SplashPageHeader, {}), /*#__PURE__*/_jsx(SegmentedTabs, {
        selectedTab: tab,
        path: "/splash",
        bordered: true,
        use: "enclosed-shaded"
      })]
    }), /*#__PURE__*/_jsxs("main", {
      role: "main",
      children: [tab === ENTERPRISE ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ProductsSection, {
          selectedTab: tab,
          sectionProps: {
            use: 'shaded'
          }
        }), /*#__PURE__*/_jsx(SuiteSection, {
          selectedTab: tab
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SuiteSection, {
          selectedTab: tab,
          sectionProps: {
            use: 'shaded'
          }
        }), /*#__PURE__*/_jsx(ProductsSection, {
          selectedTab: tab
        })]
      }), /*#__PURE__*/_jsx(PowerOfHubSpotSection, {
        sourceId: "pricing-pages-splash-page",
        selectedTab: tab
      })]
    })]
  });
};
export default SplashPage;